import { EnvUtils } from '@ecm/dispatcher';

import { environmentBase } from './environment.base';

export const environment = {
    production: true,
    basicat: environmentBase.basicat,
    version: environmentBase.version,
    eclair: environmentBase.eclair,
    webview: environmentBase.webview,
    standalone: environmentBase.standalone,
};

EnvUtils.production = environment.production;
EnvUtils.basicat = environment.basicat;
EnvUtils.eclair = environment.eclair;
EnvUtils.webview = environment.webview;
EnvUtils.standalone = environmentBase.standalone;
EnvUtils.version = environmentBase.version;
